<div class="modal-header">
  <h4 class="modal-title">Fila de Atendimento</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
  <div class="fila-container">
    <div *ngFor="let assunto of atendimentos" class="assunto-container">
      <h4 class="assunto-titulo">{{ assunto.nomeAssuno }}</h4>
      <ul class="ul-user">
        <li *ngFor="let user of assunto.operadores" class="li-user">
          <div class="user-info">
            <div class="status-indicator" [ngClass]="{'online': user.online}"></div>
            <span class="user-name">{{ user.nome }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">Fechar</button>
</div> 